import React from 'react';
import PropTypes from 'prop-types';

import Countdown from './Countdown';
import BaseModal from './BaseModal';
import ProgressBar from './ProgressBar';

class TimeDelayedModal extends React.PureComponent {
    static propTypes = {
        delay: PropTypes.number.isRequired,
        footerLoader: PropTypes.func,
        children: PropTypes.any,
        show: PropTypes.bool
    };

    static defaultProps = {
        show: true,
        footerLoader: ({ completed, total }) => (
            <div className="countdown-progressbar margin-top--sm">
                <ProgressBar completed={completed} total={total} />
            </div>
        )
    }

    render () {
        const { show, delay, children, footerLoader: FooterLoader, ...modalProps } = this.props;
        if (!show) {
            return null;
        }

        return (
            <Countdown start={ delay }>{
                ({ counter: timeRemaining, isCounting }) => (
                    <BaseModal
                        disableClose={ isCounting }
                        disableContinue={ isCounting }
                        disableEscape={ isCounting }
                        footerContent={
                            isCounting
                                ? <FooterLoader completed={ delay - timeRemaining } total={delay} />
                                : null
                        }
                        { ...modalProps }
                    >
                        { children }
                    </BaseModal>
                )
            }</Countdown>
        );
    }

}

export default TimeDelayedModal;



// WEBPACK FOOTER //
// ./src/components/general/TimeDelayedModal.js